/* eslint-disable */
import React, { Component } from "react";
import PropTypes from "prop-types";
import store from "./state/store";
import Search from "./state/actions/Search";
import { setMainTranscript } from "./state/helpers/setMainTranscript";
import { SetVariantAnnotationModeAction } from "./state/actions/GermlineSomaticActions";
import ThrottlingHubspotBanner from "./components/throttling/ThrottlingHubspotBanner";
import Error from "./components/atoms/Error/Error";
import AccountTypeThrottlingMessage from "./components/throttling/AccountTypeThrottlingMessage";

export default class VariantRequest extends Component {
  componentWillMount() {
    this.setState(store.getState());
    store.subscribe(() => {
      this.setState(store.getState());
    });
    const { apiurl } = this.props;
    if (!window.varsomeConfig && apiurl) {
      store.dispatch({
        type: "SET_VARSOME_CONFIG",
        config: {
          apiUrl: apiurl,
        },
      });
    }
  }

  componentDidMount() {
    // If there's an initial query from prop(attr), start requests
    // (for embedding components in 3rd party page)
    const { refgenome, query } = this.props;
    if (refgenome) {
      const name = refgenome;
      const id = `10${name.substring(2, 4)}`;
      const genome = { name, id };
      store.dispatch({ type: "SET_SEARCH_OPTIONS", options: { genome } });
    }
    if (query) {
      store.dispatch({ type: "SET_USER_QUERY", userQuery: query });
      Search();
    }
  }

  componentWillReceiveProps(props) {
    // For embedding components:
    // can accept either (refgenome, query) or (schema, result)
    const { refgenome, query, schema, result } = this.props;
    const {
      cancerType,
      tissueType,
      age,
      sex,
      ethnicity,
      annotationMode,
      diseases,
      phenotypes,
      inheritance,
      hasJaxckbEnabled,
    } = props;
    if (props.refgenome && props.refgenome !== refgenome) {
      const name = refgenome;
      const id = `10${name.substring(2, 4)}`;
      const genome = { name, id };
      store.dispatch({ type: "SET_SEARCH_OPTIONS", options: { genome } });
    }
    if (props.query && props.query !== query) {
      store.dispatch({ type: "SET_USER_QUERY", userQuery: props.query });
      if (annotationMode) {
        const params = {
          annotation_mode: annotationMode,
          cancer_type: cancerType ? cancerType.split(",") : "",
          tissue_type: tissueType ? tissueType.split(",") : "",
          age: age || "",
          ethnicity: ethnicity || "",
          sex: sex || "",
          hasJaxckbEnabled: hasJaxckbEnabled,
        };
        store.dispatch(SetVariantAnnotationModeAction(params));
      }

      Search();
    }
    if (props.schema && props.schema !== schema) {
      let schema = JSON.parse(decodeURIComponent(props.schema));
      store.dispatch({
        type: "SET_SCHEMA",
        result: { schema },
      });
    }
    if (props.result && props.result !== result) {
      const res = JSON.parse(decodeURIComponent(props.result));

      for (let i = 0; i < res.length; i++) {
        setMainTranscript(res[i]);
      }

      store.dispatch({
        type: "SET_MULTIPLE_RESULTS",
        multipleResults: res,
      });

      store.dispatch({
        type: "SET_CURRENT_VARIANT",
        result: {
          variantResult: res[0],
        },
      });
    }
    // Highlighting tissue and cancer types when a somatic analysis is run on VarSome Clinical.
    if (cancerType || tissueType || age || ethnicity || sex || inheritance) {
      const params = {
        annotation_mode: "somatic",
        cancer_type: cancerType ? cancerType.split(",") : "",
        tissue_type: tissueType ? tissueType.split(",") : "",
        age: age || "",
        ethnicity: ethnicity || "",
        sex: sex || "",
        inheritance: inheritance || "",
      };
      store.dispatch(SetVariantAnnotationModeAction(params));
    }
    if (diseases || phenotypes) {
      const params = {
        annotation_mode: "germline",
        phenotypes,
        diseases,
      };
      store.dispatch(SetVariantAnnotationModeAction(params));
    }
  }

  render() {
    const { user, error, errorId } = this.state;
    if (!error) return null;

    if (errorId !== 429) return <Error error={error} />;

    // TODO: write down all the cases for 429 errors
    return (
      <div
        style={{ minHeight: "calc(100vh - 60px)" }}
        className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full tw-font-sans"
      >
        <AccountTypeThrottlingMessage user={user} error={error} />
        {user.is_varsome_premium_subscriber ? null : (
          <ThrottlingHubspotBanner varsomeHost={store.getState().varsomeHost} />
        )}
      </div>
    );
  }
}

VariantRequest.propTypes = {
  refgenome: PropTypes.string,
  query: PropTypes.string,
  apiurl: PropTypes.string,
  usertoken: PropTypes.string,
};

VariantRequest.defaultProps = {
  refgenome: "",
  query: "",
  apiurl: "",
  usertoken: "",
};
